import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { NonAuthLayout } from 'src/components/templates/nonAuth/NonAuthLayout';
import { GuestGuard } from './GuestGuard';
import { LazyLoader } from './LazyLoader';

const Login = LazyLoader(lazy(() => import('src/components/pages/login/LoginPage')));
const Register = LazyLoader(lazy(() => import('src/components/pages/register/RegisterPage')));
const ResetPassword = LazyLoader(lazy(() => import('src/components/pages/resetPassword/ResetPasswordPage')));

export const nonAuthPageRoutes = {
  path: 'auth',
  element: (
    <GuestGuard>
      <NonAuthLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: '/auth',
      element: <Navigate to='/auth/login' />
    },
    {
      path: 'login',
      element: <Login type='non-auth' title='pages.login.title_head' />
    },
    {
      path: 'register',
      element: <Register type='non-auth' title='pages.register.title_head' />
    },
    {
      path: 'reset-password',
      element: <ResetPassword type='non-auth' title='pages.reset_password.title_head' />
    },
    {
      path: '*',
      element: <Navigate to='/auth/login' />
    }
  ]
};

export type NonAuthPageTitle =
  | 'pages.login.title_head'
  | 'pages.register.title_head'
  | 'pages.reset_password.title_head';
